<template>
    <div class="row pb-4">
        <div class="col-12">
            <div class="alert alert-secondary py-4" style="background-color: #ececec;">
                <div class="row">
                    <div class="col-12 pb-4">
                        <div class="btn-group btn-block" role="group" aria-label="Basic example">
                            <button @click="currentTab = 'temperature'" :class="{ active : currentTab === 'temperature' }" class="btn font-weight-bold btn-outline-danger">℃
                            </button>
                            <button @click="currentTab = 'humidity'" :class="{ active : currentTab === 'humidity' }" class="btn font-weight-bold btn-outline-danger">Вологість
                            </button>
                            <button @click="currentTab = 'pressure'" :class="{ active : currentTab === 'pressure' }" class="btn font-weight-bold btn-outline-danger">Тиск</button>
                            <button @click="currentTab = 'PM25'" :class="{ active : currentTab === 'PM25' }" class="btn font-weight-bold btn-outline-danger">PM 2.5</button>
                            <button @click="currentTab = 'PM10'" :class="{ active : currentTab === 'PM10' }" class="btn font-weight-bold btn-outline-danger">PM 10</button>
                            <button @click="currentTab = 'CO2'" :class="{ active : currentTab === 'CO2' }" class="btn font-weight-bold btn-outline-danger">CO2</button>
                        </div>
                    </div>
                    <div class="col-12 pb-4">
                        <DatePicker @change="(period) => currentPeriod = period"/>
                    </div>
                    <div class="col-12" style="overflow-x: auto;">
                        <LineChart style="min-width: 1000px; width: 100%;" :chartData="chartData" :options="options"/>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import LineChart from "./LineChart";
import moment from "moment-mini";
import DatePicker from "./DatePicker";
import ChartDataPreparer from "@/classes/ChartDataPreparer";

export default {
    name: "LocalityChart",
    components: {
        LineChart,
        DatePicker
    },
    props: ["device", "data", "labelsTime"],
    data() {
        return {
            init: false,
            currentTab: "temperature",
            currentPeriod: "12",
            tabs: {
                temperature: "Температура повітря (℃)",
                humidity: "Відносна вологість (%)",
                PM25: "Концентрація частинок пилу PM 2.5 (мкг/м³)",
                PM10: "Концентрація частинок пилу PM 10 (мкг/м³)",
                CO2: "Концентрація CO2 (ppm)",
                pressure: "Атмосферний тиск (мм. рт. ст)",
            },
            colors: {
                temperature: "#4CB051",
                humidity: "#EB1E63",
                PM25: "#2196F3",
                PM10: "#663BB7",
                CO2: "#FEC106",
                pressure: "#01BCD6",
            },
            backgrounds: {
                temperature: "rgba(76,176,81,0.5)",
                humidity: "rgba(235,30,99,0.5)",
                PM25: "rgba(33,150,243,0.5)",
                PM10: "rgba(102,59,183,0.5)",
                CO2: "rgba(254,193,6,0.5)",
                pressure: "rgba(1,188,214,0.5)",
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [{
                        ticks: {
                            autoSkip: true,
                        }
                    }],
                    yAxes: [{
                        ticks: {
                            suggestedMin: 0,
                        }
                    }]
                }
            },
        }
    },
    computed: {
        chartData() {
            if (!this?.data?.data?.length) {
                return {};
            }

            //let data = this.data.data.reverse().map(item => {
            let data = this.data.data.map(item => {
                // паскали в мм. рт. ст.
                if (this.currentTab === 'pressure') {
                    return {
                        value: ((item[this.currentTab]) / 13.33224).toFixed(0),
                        datetime: moment(item.datetime).format("YYYY-MM-DD HH:mm")
                    };
                }

                return {
                    value: item[this.currentTab],
                    datetime: moment(item.datetime).format("YYYY-MM-DD HH:mm")
                };
            });

            const composer = new ChartDataPreparer(data);

            let chart;

            if (["12", "24", "48"].indexOf(this.currentPeriod) !== - 1) {
                chart = composer.byHours(this.currentPeriod);
            } else if (this.currentPeriod === "week") {
                chart = composer.byDays(7);
            } else if (this.currentPeriod === "month") {
                chart = composer.byDays(30);
            }

            return {
                labels: chart.labels,
                datasets: [{
                    label: this.tabs[this.currentTab],
                    backgroundColor: this.backgrounds[this.currentTab],
                    borderColor: this.colors[this.currentTab],
                    data: chart.chartData,
                    pointRadius: 3,
                    borderWidth: 3
                }]
            }
        },
    },
}

</script>